import { useEffect } from 'react';

import { getEnvironmentName } from '@/utils/helpers/environment';

const GTM_SCRIPT_ID = 'gtm-script';

/**
 * Resolves initial dataLayer2 context from the current environment and URL query params.
 */
function getDataLayerContext(): Record<string, unknown> {
  const params = new URLSearchParams(window.location.search);

  // env_work
  const envName = getEnvironmentName();
  const env_work = envName === 'prod' ? 'prod' : 'preprod';

  // env_language — locale comes from Auth0 ACUL transaction context, not URL params
  const locale = window.universal_login_context?.transaction?.locale ?? 'fr';
  const env_language = locale.toUpperCase();

  // env_segment
  const env_segment = 'residential';

  // UTM parameters
  const utms: Record<string, string> = {};
  params.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utms[key] = value;
    }
  });

  return {
    env_work,
    env_language,
    env_segment,
    ...utms,
  };
}

export const useGtmScript = () => {
  useEffect(() => {
    const gtmId = import.meta.env.VITE_GTM_ID;

    if (!gtmId || document.getElementById(GTM_SCRIPT_ID)) {
      return;
    }

    const context = getDataLayerContext();

    // Initialize tc_vars with context so TagCommander tags have access to environment info
    window.tc_vars = { ...window.tc_vars, ...context };

    // Initialize dataLayer2 and push initial context
    window.dataLayer2 ||= [];
    window.dataLayer2.push({
      'gtm.start': Date.now(),
      event: 'gtm.js',
      ...context,
    });

    const script = document.createElement('script');
    script.id = GTM_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}&l=dataLayer2`;
    document.head.appendChild(script);
  }, []);
};
